import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { StyledCheckboxItemDiv, StyledCheckboxItemsContainer } from '../../organisms/SearchResults/index.styles';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledAmenitiesFilterDiv = styled.div`
  ${rtl`
  padding-top: ${toRem(24)};
  .checkbox-controls-list__checkbox label{
    font-weight: ${baseVariables.font['fontWeightRegular']};
  }
  .checkbox-controls-list {
    padding-left:0;
     @media only ${baseVariables.mediaQuery.md} {
      .checkbox-controls-list__title{
        margin-top: ${toRem(-32)};
      }
     }
    
    .show-more-btn{
      font-size: ${baseVariables.font['fontXs']};
      font-weight: ${baseVariables.font['fontWeightMedium']};
    }
  }
  .tooltip-amenity {
    align-content: end;
    padding-left: ${toRem(1)};
    margin-bottom: ${toRem(-2)};
    position: relative;
    .tooltip-information {
     
      .tooltip-icon {
        position: relative;
        padding: 0;
        &:after {
          position: relative;
          top: ${toRem(2)};
          font-size: ${toRem(16)};
        }
        &:hover {
          background-color: transparent;
        }
        &:focus {
          border: none;
        }
        .tooltip-dialog {
          position: absolute;
          transform: translateX(-46%) translateY(-74%);
          z-index: 1;
        }
      }
      .m-link-icon-button-info{
        &:after{
          padding: 0;
        }
      }
    }
  }

  ${StyledCheckboxItemDiv} {
    input[type='checkbox'] + label {
      &.checkbox-label {
        padding-left: ${toRem(30)};
        padding-right: 0;
        width: fit-content;
      }
    }
  }

  @media only ${theme.mediaQuery.allMobiles} {
    padding-top: 0;
    padding-bottom: 0;
    ${StyledCheckboxItemDiv} {
      width: 100%;
    }
    ${StyledCheckboxItemsContainer} {
      margin-bottom: ${toRem(16)};
    }
  }

  .show-more-less-option {
    display: flex;
    align-items: flex-start;
    margin-top: ${toRem(8)};

    .icon-arrow-up,
    .icon-arrow-down {
      margin-left: ${toRem(6)};
    }
    &:hover {
      cursor: pointer;
    }
  }
  `}
`;

export const StyledAmenitiesModalFilterDiv = styled.div`
  ${rtl`
  .pop-up-footer {
    padding: ${toRem(12)} ${toRem(16)};
    @media ${baseVariables.mediaQuery.md} {
      padding: ${toRem(20)} ${toRem(32)};
    }
  }
  .filter-option-button.active {
    background-color: ${theme.color['close-silver']};
  }
  .filter-option-button {
    font-weight: ${theme.fonts['fontWeightRegular']};
  }
  .filter-option-button:focus {
    outline: 0px solid -webkit-focus-ring-color;
  }
  `}
`;
